<script setup>
import { computed, useAttrs } from 'vue';

const attrs = useAttrs();

const classes = computed(() => {
  return `${!attrs.classes ? 'flex item-center gap-4 md:flex-row' : attrs.classes} ${
    !attrs.row ? ' flex-col' : ' '
  }`;
});
</script>
<template>
  <div :class="classes" v-bind="$attrs">
    <component
      v-for="(i, index) in $attrs.ui"
      :is="$attrs.is"
      :key="index"
      v-bind="i"
      :class="[{ 'flex-1': !i.noFlex }, i.class]"
    />
    <!-- test -->
  </div>
</template>

<script>
import Row from './Row.vue';
import TSelect from './TSelect.vue';
import TSeparator from './TSeparator.vue';
import TRadio from './TRadio.vue';
import TInput from './TInput.vue';
import TDate from './TDate.vue';
import TTime from './TTime.vue';
import TUploads from './TUploads.vue';
import TCheckbox from './TCheckbox.vue';
import TTextarea from './TTextarea.vue';

export default {
  inheritAttrs: false,
  components: {
    Row,
    TSelect,
    TSeparator,
    TRadio,
    TInput,
    TDate,
    TTime,
    TUploads,
    TCheckbox,
    TTextarea,
  },
};
</script>
